import { useCallback, useEffect, useMemo, useState } from 'react';

const STORAGE_KEY = 'lolcator-pinned';

const readPinned = () => {
    try {
        const stored = JSON.parse( localStorage.getItem( STORAGE_KEY ) );

        return Array.isArray( stored ) ? stored : [];
    } catch ( error ) {
        return [];
    }
};

// Pinned colleagues are stored by identity (not by device), so a pin sticks
// even when the person is offline and comes back later.
export const usePinnedPeople = () => {
    const [ pinnedList, setPinnedList ] = useState( readPinned );

    useEffect( () => {
        try {
            localStorage.setItem( STORAGE_KEY, JSON.stringify( pinnedList ) );
        } catch ( error ) {
            // Storage can be full or blocked (private mode) — pins then last
            // for the session only.
        }
    }, [ pinnedList ] );

    const pinned = useMemo( () => new Set( pinnedList ), [ pinnedList ] );

    const togglePin = useCallback( ( identity ) => {
        setPinnedList( ( current ) => {
            return current.includes( identity )
                ? current.filter( ( pinnedIdentity ) => pinnedIdentity !== identity )
                : [ ...current, identity ];
        } );
    }, [] );

    return { pinned, togglePin };
};
